import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";
import GenericInputComponent from "../GenericInputComponent";
import FormFieldWrapper from "../FormFieldWrapper";
import { formInputId, getValidationResult } from "../../formHelpers";
import ErrorBlock from "../ErrorBlock";

class TextAreaWidgetComponent extends GenericInputComponent {
  render() {
    const { widget, inputsWithErrors } = this.props;
    const myStorage = isBrowser ? window.sessionStorage : {};
    const placeholder = widget.get("placeholder");
    const validation = getValidationResult(inputsWithErrors, widget.id());

    return (
      <div
        className={classNames("form-group", {
          invalid: !!validation,
        })}
      >
        <FormFieldWrapper widget={widget}>
          <textarea
            id={formInputId(widget)}
            rows="4"
            className="form-control"
            placeholder={placeholder}
            onChange={this.handleInputChange}
            value={myStorage.getItem(widget.id()) || ""}
          />
        </FormFieldWrapper>
        <ErrorBlock validation={validation} lang={widget.obj().language()} />
      </div>
    );
  }
}

Scrivito.provideComponent("TextAreaWidget", TextAreaWidgetComponent);
